import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { RouteFragment } from "../../../../../../react-core/Imports";
import { AvailableProductWrappersClient } from "../../../../../../Wrap/Api/ProductWrappers/AvailableProductWrappers";
import { QuoteContributionsClient } from "../../../../../../Wrap/Api/Quote/QuoteContributions";
import { QuoteCopyInstructionClient } from "../../../../../../Wrap/Api/Quote/QuoteCopyInstruction";
import { QuoteInstructionClient } from "../../../../../../Wrap/Api/Quote/QuoteInstruction";
import { QuoteModel } from "../../../../../../Wrap/Models/Models/Processes/Quote/QuoteModel";
import { Navigator } from "../../../../../Shared/Wizards/Entities/Navigator";
import { getQueryParameters } from "../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { ProductWrapperDispatcher, QuoteInstructionDispatcher, QuoteInstructionStore } from "../Store/Variable";

export class NewQuoteAction {
    public static getQuoteInstruction(id): void {
        const client = new QuoteInstructionClient();
        const promise = client.get(id, null);
        promise.onSuccess((result) => {
            QuoteInstructionDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: result,
            });
        });

        promise.onError((err) => {
            QuoteInstructionDispatcher.dispatch({
                actionType: ActionType.Error,
                payload: err,
            });
        });
    }

    public static saveQuoteInstruction(from, data: QuoteModel, callback?: (data) => void): void {
        let promise;
        
        if (from == 0) {
            const client = new QuoteInstructionClient();
            promise = client.post(data);
          
        } else {
            const client = new QuoteContributionsClient();
            promise = client.put(data);
        }

        promise.onSuccess((result) => {
            QuoteInstructionDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: result,
            });
            if (callback) {callback([]);}
        });

        promise.onError((err) => {
            QuoteInstructionDispatcher.dispatch({
                actionType: ActionType.Error,
                payload: err,
            });
        });
    }

    public static submitQuoteInstruction(id, callback?: VoidFunction): void {
        const client = new QuoteInstructionClient();
        const promise = client.put(id);
        promise.onSuccess(() => {
            callback();
        });
    }
 
    public static deleteQuoteInstruction(id, callback?: VoidFunction): void {
        if (!id) {
            callback();
            return;
        }

        const client = new QuoteInstructionClient();
        const promise = client.delete(id);
        promise.onSuccess(() => {
            callback();
        });
    }

    public static getProductWrappers(customerId: number, servicePropositionId: number) {
        const client = new AvailableProductWrappersClient();
        const promise = client.get(customerId, servicePropositionId, true);

        promise.onSuccess((data) => {
            ProductWrapperDispatcher.dispatch({
                actionType: ActionType.Update,
                payload: data,
            });
        });
        promise.onError((err) => {});
    }

    public static copyQuoteInstruction(router: RouteFragment) {
        QuoteInstructionDispatcher.dispatch({
            actionType: ActionType.Loading,
            payload: true,
        });
        const quoteModel = QuoteInstructionStore.getData();
        const quoteCopy = new QuoteCopyInstructionClient();
        const promise = quoteCopy.put(quoteModel);
        promise
            .onSuccess((result: QuoteModel) => {
                QuoteInstructionDispatcher.dispatch({
                    actionType: ActionType.Success,
                    payload: result,
                });
                QuoteInstructionDispatcher.dispatch({
                    actionType: ActionType.Loading,
                    payload: false,
                });
                Navigator.navigateTo(router, {
                    scrollAfterNavigating: true,
                    queryParamsObject: {
                        customerid: getQueryParameters()["customerid"],
                        id: result.AccountRoleInstructionId,
                    },
                });
            })
            .onError((error) => {
                QuoteInstructionDispatcher.dispatch({
                    actionType: ActionType.Error,
                    payload: error,
                });
            });
    }
}
